import { Filters } from "@/types/filters";

type RangeValue = {
	min: number;
	max: number;
};

function isRangeValue(value: unknown): value is RangeValue {
	return typeof value === "object" && value !== null && "min" in value && "max" in value;
}

export function getActiveFiltersCount(filters: Partial<Filters>): number {
	// Use the same valid filter keys as SelectedFilters component
	const validFilterKeys = new Set([
		"locations",
		"propertyType",
		"bedrooms",
		"bathroomsMin",
		"budget",
		"builtupAreaMin",
		"floors",
		"balconiesMin",
		"parkingsMin",
		"rentalValue",
		"facing",
		"furnishing",
		"status",
		"amenities",
		"documents",
		"spaces",
		"waterSources",
		"levelType",
	]);

	const activeFilters = Object.entries(filters).filter(([key, value]) => {
		// Only count valid user-facing filter keys (same as SelectedFilters)
		if (!validFilterKeys.has(key)) return false;
		if (key === "bounds") return false;
		if (Array.isArray(value)) return value.length > 0;
		if (typeof value === "object" && value !== null) {
			if (isRangeValue(value)) {
				return value.min > 0 || value.max > 0;
			}
			return Object.keys(value).length > 0;
		}
		if (typeof value === "string") return value && value !== "apartment"; // Exclude default propertyType
		if (typeof value === "number") return value > 0;
		return false;
	});

	return activeFilters.length;
}
